var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 41,
    viewBox: "0 0 45 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3884 0.980408H42.1354L27.3953 17.8274L44.7359 40.7523H31.1583L20.5239 26.8485L8.35577 40.7523H1.60473L17.3707 22.7326L0.73587 0.980408H14.6581L24.2707 13.6891L35.3884 0.980408ZM33.0205 36.714H36.759L12.6267 4.80667H8.61479L33.0205 36.714Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.8d846d46dda62fcab9dab4481f530ffb.svg";
export { ForwardRef as ReactComponent };